/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var UserActivityEvent;
(function (UserActivityEvent) {
    UserActivityEvent["TIME_SPENT"] = "TIME_SPENT";
})(UserActivityEvent || (UserActivityEvent = {}));
export function UserActivityEventFromJSON(json) {
    return UserActivityEventFromJSONTyped(json, false);
}
export function UserActivityEventFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function UserActivityEventToJSON(value) {
    return value;
}
